<app-module-menu-wrapper style="height: 100% !important;" [title]="title" [menuItems]="menuItems">
</app-module-menu-wrapper>
